<form (ngSubmit)="onSubmit()" [formGroup]="personalInformationFormGroup">
  <div class="row">
    <div class="col-xs-12 col-md-7 form-group">
      <label for="title" class="zaya-form-sub-header" i18n="label|Professional title of practitioner.@@labelProfessionalTitle">What is your profession?</label>
      <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the practitioner professional title.@@labelApplicationProfessionalTitleHelpText">
        eg. Acupuncturist, Psychotherapist, Physiotherapist, etc.
      </div>
      <input type="text" id="title" class="form-control" formControlName="title">
      <span
        class="help-block"
        *ngIf="personalInformationFormGroup.get('title').invalid && personalInformationFormGroup.get('title').touched"
        i18n="error message|The message shown when a title has not been entered.@@errorProfessionalTitle">
          Please enter a valid professional title.
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-2 col-md-2 form-group">
      <label for="salutation" class="zaya-form-sub-header" i18n="label|Salutation of practitioner.@@labelSalutation">Salutation</label>
      <input type="text" id="salutation" class="form-control" formControlName="salutation">
    </div>
    <div class="col-xs-12 col-md-5 form-group">
      <label for="firstName" class="zaya-form-sub-header" i18n="label|First name of practitioner.@@labelFirstName">First name</label>
      <input type="text" id="firstName" class="form-control" formControlName="firstName">
      <span
        class="help-block"
        *ngIf="personalInformationFormGroup.get('firstName').invalid && personalInformationFormGroup.get('firstName').touched"
        i18n="error message|The message shown when a first name has not been entered.@@errorFirstName">
          Please enter a valid first name.
      </span>
    </div>
    <div class="col-xs-12 col-md-5 form-group">
      <label for="lastName" class="zaya-form-sub-header" i18n="label|Last name of practitioner.@@labelLastName">Last name</label>
      <input type="text" id="lastName" class="form-control" formControlName="lastName">
      <span
        class="help-block"
        *ngIf="personalInformationFormGroup.get('lastName').invalid && personalInformationFormGroup.get('lastName').touched"
        i18n="error message|The message shown when a last name has not been entered.@@errorLastName">
          Please enter a valid last name.
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-6 form-group">
      <label for="gender" class="zaya-form-sub-header" i18n="label|The gender of a user.@@labelGender">Gender</label>
      <select id="gender" class="form-control" formControlName="gender">
        <option *ngFor="let gender of genders" [value]="gender" i18n="label|Options used for selecting gender.@@labelGenderOptions">
          { gender, select, Male {Male} Female {Female} Non-binary {Non-binary}}
        </option>
      </select>
      <span
        class="help-block"
        *ngIf="personalInformationFormGroup.get('gender').invalid && personalInformationFormGroup.get('gender').touched"
        i18n="error message|The message shown when a gender has not been selected.@@errorGender">
          Please select a gender.
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-6 form-group">
      <label for="email" class="zaya-form-sub-header" i18n="label|The email of a user.@@labelWorkEmail">Work email</label>
      <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the work email of a practitioner.@@labelApplicationWorkEmailHelpText">
        This information will not be listed on your profile.
      </div>
      <input type="email" id="email" class="form-control" formControlName="email">
      <span
        class="help-block"
        *ngIf="personalInformationFormGroup.get('email').invalid && personalInformationFormGroup.get('email').touched"
        i18n="error message|The message shown when an email has not been entered.@@errorEmail">
          Please enter a valid email.
      </span>
    </div>
    <div class="col-xs-12 col-md-6 form-group">
      <label for="phoneNumber" class="zaya-form-sub-header" i18n="label|The phone number of a user.@@labelPhoneNumber">Phone number</label>
      <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for phone number of a practitioner.@@labelApplicationPhoneNumberHelpText">
        This information will not be listed on your profile.
      </div>
      <input type="tel" id="phoneNumber" class="form-control" formControlName="phoneNumber">
      <span
        class="help-block"
        *ngIf="personalInformationFormGroup.get('phoneNumber').invalid && personalInformationFormGroup.get('phoneNumber').touched"
        i18n="error message|The message shown when a phone number has not been entered.@@errorPhoneNumber">
          Please enter a valid phone number.
      </span>
    </div>
  </div>

  <hr>

  <div class="d-flex flex-fill justify-content-center">
    <button type="submit" class="btn btn-primary modal-btn mr-2" [disabled]="!personalInformationFormGroup.valid || isLoading">Submit</button>
    <button type="button" class="btn btn-secondary modal-btn" (click)="onDismiss()">Cancel</button>
  </div>
</form>
